(function () {
  'use strict';

  if (window.bbDesktopCartInit) return;
  window.bbDesktopCartInit = true;

  function isDesktop() { return window.innerWidth >= 750; }

  function buildActionBar(row) {
    if (row.querySelector('.bb-desk-actions')) return;

    var detailsTd = row.querySelector('td.cart-item__details');
    if (!detailsTd) return;

    // Outer flex-column div that fills the full td height
    var layout = document.createElement('div');
    layout.className = 'bb-desk-layout';

    // Inner div holds the existing product content
    var inner = document.createElement('div');
    inner.className = 'bb-desk-inner';
    while (detailsTd.firstChild) inner.appendChild(detailsTd.firstChild);
    layout.appendChild(inner);

    var bar = document.createElement('div');
    bar.className = 'bb-desk-actions';

    var deskQtyStyle = window.bbDeskQtyStyle || 'shein';

    // ── Qty control ──────────────────────────────────────────────────
    var qtyControl = null;

    if (deskQtyStyle === 'shein') {
      var qtyTd = row.querySelector('td.cart-item__quantity');
      var input = qtyTd ? qtyTd.querySelector('.quantity__input') : null;
      var lineIndex = parseInt(row.getAttribute('data-line'), 10) || 1;
      var qty = input ? (parseInt(input.value, 10) || 1) : 1;

      var pill = document.createElement('button');
      pill.className = 'bb-desk-qty-pill';
      pill.type = 'button';
      pill.dataset.lineIndex = lineIndex;
      pill.dataset.qty = qty;
      pill.innerHTML =
        '<span class="bb-desk-qty-label">Qty:</span>' +
        '<span class="bb-desk-qty-val">' + qty + '</span>' +
        '<span class="bb-desk-qty-arrow">&#9662;</span>';
      pill.addEventListener('click', function () {
        if (window.bbOpenQtyPopup) window.bbOpenQtyPopup(pill);
      });
      qtyControl = pill;
    } else {
      var qtyTd2 = row.querySelector('td.cart-item__quantity');
      var qtySel = qtyTd2 ? qtyTd2.querySelector('quantity-selector-component') : null;
      if (qtySel) qtyControl = qtySel;
    }

    // ── Other controls ───────────────────────────────────────────────
    var sflBtn = inner.querySelector('.bb-sfl-btn');
    var removeTd = row.querySelector('td.cart-item__remove');
    var trashBtn = removeTd ? removeTd.querySelector('.button-close-circle') : null;

    // ── Ordering ─────────────────────────────────────────────────────
    var pos = window.bbSflDeskPosition || 'middle';

    if (pos === 'first') {
      if (sflBtn) bar.appendChild(sflBtn);
      if (qtyControl) bar.appendChild(qtyControl);
      if (trashBtn) bar.appendChild(trashBtn);
    } else if (pos === 'last') {
      if (qtyControl) bar.appendChild(qtyControl);
      if (trashBtn) bar.appendChild(trashBtn);
      if (sflBtn) bar.appendChild(sflBtn);
    } else {
      if (qtyControl) bar.appendChild(qtyControl);
      if (sflBtn) bar.appendChild(sflBtn);
      if (trashBtn) bar.appendChild(trashBtn);
    }

    if (bar.children.length > 0) {
      layout.appendChild(bar);
    }

    detailsTd.appendChild(layout);
  }

  function init() {
    if (!isDesktop()) return;

    document.body.classList.toggle('bb-sfl-icon-mode', window.bbSflDesktopStyle === 'icon');
    document.body.classList.toggle('bb-desk-qty-compact', window.bbDeskQtyStyle === 'compact');

    document.querySelectorAll('tr.cart-item').forEach(function (row) {
      buildActionBar(row);
    });
  }

  var reInitTimer;
  function scheduleInit() {
    clearTimeout(reInitTimer);
    reInitTimer = setTimeout(init, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Primary trigger: standard cart update event
  document.addEventListener('cart:updated', scheduleInit);

  // Fallback: MutationObserver catches re-renders that don't fire cart:updated.
  // Watch document.body (not #main-cart) because Shopify AJAX section rendering
  // can replace the #main-cart element entirely (outerHTML swap), which detaches
  // any observer targeting it.
  new MutationObserver(function (mutations) {
    var hasNewRows = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          (n.matches && n.matches('tr.cart-item')) ||
          (n.querySelector && n.querySelector('tr.cart-item'))
        );
      });
    });
    if (hasNewRows) scheduleInit();
  }).observe(document.body, { childList: true, subtree: true });
})();
